module.exports = __webpack_public_path__ + "de166d00c6cfadb88d55872ed9faf14f.MP3";